var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.571429,
    y: 0.571429,
    width: 30.8571,
    height: 30.8571,
    rx: 8.57143,
    transform: "matrix(-1 0 0 1 30.8571 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.571429,
    y: 0.571429,
    width: 30.8571,
    height: 30.8571,
    rx: 8.57143,
    transform: "matrix(-1 0 0 1 30.8571 0)",
    stroke: "#E7E6E8",
    strokeWidth: 1.14286
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 10.9997C9.3335 10.5576 9.50909 10.1337 9.82165 9.82116C10.1342 9.5086 10.5581 9.33301 11.0002 9.33301H21.0002C21.4422 9.33301 21.8661 9.5086 22.1787 9.82116C22.4912 10.1337 22.6668 10.5576 22.6668 10.9997V20.9997C22.6668 21.4417 22.4912 21.8656 22.1787 22.1782C21.8661 22.4907 21.4422 22.6663 21.0002 22.6663H11.0002C10.5581 22.6663 10.1342 22.4907 9.82165 22.1782C9.50909 21.8656 9.3335 21.4417 9.3335 20.9997V10.9997Z",
    stroke: "#67308F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.33301V22.6663",
    stroke: "#67308F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 14.3335L16.8333 16.0002L18.4999 17.6668",
    stroke: "#67308F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.8ea37e027f2a4dbb20e7d9c7a9e8d2cc.svg";
export { ForwardRef as ReactComponent };